export default {
    visits: 'Plan visits',
    'visits-done': 'visits done (current month)',
    'month-visits': 'Month visits(until today)',
    'leave-requests': 'Leave requests',
    'administrative-day': 'Administrative day',
    'modification-requests': 'Modification requests',
    'customer-addition-requests': 'Customer addition requests',
    'customer-deletion-requests': 'Customer deletion requests',

    'number-of-visits-for-the-last-month-according-to-classification': 'Number of visits for the last month according to classification',
    'number-of-employees-per-role': 'Number of employees per role',
    'number-of-visits-for-the-last-week-depending-on-the-number-of-customers': 'Number of visits for the last week depending on the number of customers',
    'welcome-new-members': 'Welcome new members',
    'outgoing-and-remaining-materials': 'Outgoing and remaining materials',
    'the-ten-most-widely-used-materials': 'Outgoing and remaining materials',
    'top3-commonly-used-materials': 'Top 3 commonly used materials',
    'least3-commonly-used-materials': 'Least 3 commonly used materials',
    'the-ten-stagnant-materials': 'The ten stagnant materials',
    'visit-count': 'Visit count',
    'entity-count': 'Entity count',
    'deliver-amount': 'Deliver amount',
    'remaining': 'Remaining',
    'count-employee': 'Count employee',
    'quantity-received': 'Quantity received',
    'quantity-delivered': 'Quantity delivered',
    'visits-number' : 'Visits number',
    'entities-number': 'Entities number',
    'yesterday': 'Yesterday'
}